import React, { useState } from 'react';
import Sidebar from './Sidebar';
import styles from './AdminLayout.module.css';

interface AdminLayoutProps {
    children: React.ReactNode;
    pageTitle: string; 
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children, pageTitle }) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    // Esta función recibe el estado (true/false) de Sidebar al hacer hover
    const handleSidebarToggle = (isOpen: boolean) => {
        setIsSidebarOpen(isOpen);
    };

    return (
        <div className={styles.dashboardContainer}>
            <Sidebar onToggle={handleSidebarToggle} />
            
            {/* El margen se ajusta según el estado del sidebar */}
            <main className={`${styles.mainContent} ${isSidebarOpen ? styles.mainContentOpen : ''}`}>
                {children}
            </main>
        </div>
    );
};

export default AdminLayout;